module.exports = __webpack_public_path__ + "static/media/PACRA_logo.286c12ae.png";